import { motion } from "framer-motion";

// Advocate neck band (bands) motif — minimalist SVG
export const BandLogo = ({ className = "" }) => (
  <svg viewBox="0 0 40 48" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M20 2 C14 4 9 5 9 5 L14 26 C15 30 17 33 20 34 C23 33 25 30 26 26 L31 5 C31 5 26 4 20 2 Z" stroke="currentColor" strokeWidth="1.2" />
    <path d="M20 3.5 L20 33.5" stroke="currentColor" strokeWidth="1" />
    <path d="M15 27 L14 46 L18.5 42 L20 46 L21.5 42 L26 46 L25 27" stroke="currentColor" strokeWidth="1.1" strokeLinejoin="round" />
  </svg>
);

const ease = [0.22, 1, 0.36, 1];

// Line-by-line masked reveal for headings
export const RevealLines = ({ lines, className = "", delay = 0, tag: Tag = "h2" }) => (
  <Tag className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden">
        <motion.span
          className="block"
          initial={{ y: "110%" }}
          whileInView={{ y: "0%" }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 0.9, ease, delay: delay + i * 0.09 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </Tag>
);

export const FadeUp = ({ children, delay = 0, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y: 26 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-8%" }}
    transition={{ duration: 0.8, ease, delay }}
  >
    {children}
  </motion.div>
);
